import LangKeys from "./keys";

const hinglish = {
  [LangKeys.reminders_collect_faster]: "3x Faster Payment Collect Karein",
  [LangKeys.reminders_total_dues]: "Total Dues",
  [LangKeys.reminders_all_customers]: "All Customers",
  [LangKeys.reminders_all]: "All",
  [LangKeys.reminders_customers]: "Customers",
  [LangKeys.reminders_suppliers]: "Suppliers",
  [LangKeys.reminders_search_placeholder]: "Customer ka naam ya mobile search karein...",
  [LangKeys.reminders_pending_balance]: "Pending Balance",
  [LangKeys.reminders_sent]: "Sent",
  [LangKeys.reminders_whatsapp]: "WhatsApp",
  [LangKeys.reminders_sms]: "SMS",
  [LangKeys.reminders_call]: "Call",
  [LangKeys.reminders_date]: "Date",
  [LangKeys.reminders_all_up_to_date]: "All Up to Date",
  [LangKeys.reminders_no_overdue_heading]: "Koi overdue customer nahi mila",
  [LangKeys.reminders_no_overdue_sub]: "Great! Sabhi customer dues up to date hain aur koi overdue payment nahi hai.",
  [LangKeys.reminders_view_all_customers]: "View All Customers",
  [LangKeys.reminders_no_due_today_heading]: "Aaj koi payment due nahi hai",
  [LangKeys.reminders_no_due_today_sub]: "Aaj ke liye koi payment reminder scheduled nahi hai.",
  [LangKeys.reminders_no_upcoming_heading]: "Koi upcoming reminder nahi hai",
  [LangKeys.reminders_no_upcoming_sub]: "Timely reminders bhejne ke liye collection date set karein.",
  [LangKeys.reminders_no_customers_found]: "Koi customer nahi mila",
  [LangKeys.reminders_no_customers_matched]: "Aapki search ke anusaar koi customer nahi mila.",
  [LangKeys.reminders_auto_reminder_active]: "Auto Reminder Active",
  [LangKeys.reminders_overdue_by]: "Overdue by",
  [LangKeys.reminders_due_in]: "Due in",
  [LangKeys.reminders_days]: "din",
  [LangKeys.reminders_day]: "din",
  [LangKeys.reminders_set_collection_date]: "Collection Date Set Karein",
  [LangKeys.reminders_collect_faster_sub]: "Customers se jaldi payment paayein",
  [LangKeys.reminders_pending_amount_filter]: "Pending Amount Filter (₹)",
  [LangKeys.reminders_highest_amount]: "Highest Amount",
  [LangKeys.reminders_oldest_dues]: "Oldest Dues",
  [LangKeys.reminders_by_due_date]: "Due Date ke anusaar",
  [LangKeys.reminders_min]: "Min",
  [LangKeys.reminders_max]: "Max",
  [LangKeys.reminders_to]: "to",
  [LangKeys.reminders_customers_selected]: "Customers Selected",
  [LangKeys.reminders_total]: "Total",
  [LangKeys.reminders_set_due_date_selected]: "Selected customers ki date set karein",
  [LangKeys.reminders_date_lbl]: "Date",
  [LangKeys.reminders_wa_sent_toast]: "{name} ko WhatsApp reminder bhej diya gaya!",
  [LangKeys.reminders_date_updated]: "Reminder date save ho gayi!",

  [LangKeys.reminders_bulk_success]: "Reminders successfully bhej diye gaye!",

  [LangKeys.reminders_sending]: "Save ho raha hai...",

  [LangKeys.reminders_cloud_wa]: "Cloud WhatsApp API (SMS)",

  [LangKeys.reminders_direct_wa]: "Direct WhatsApp (Free)",

  [LangKeys.reminders_no_pending_desc]: "Jab kisi customer se paise lene honge, toh wo yahan reminder list mein show honge.",

  [LangKeys.reminders_no_pending]: "Koi pending reminder nahi hai",

  [LangKeys.reminders_clear_date]: "Date Hatayein",

  [LangKeys.reminders_save_date]: "Date Save Karein",

  [LangKeys.reminders_time_lbl]: "Time",

  [LangKeys.reminders_chip_custom]: "Custom Date",

  [LangKeys.reminders_chip_1month]: "1 mahine baad",

  [LangKeys.reminders_chip_15days]: "15 din baad",

  [LangKeys.reminders_chip_1week]: "1 hafte baad",

  [LangKeys.reminders_chip_3days]: "3 din baad",

  [LangKeys.reminders_chip_tomorrow]: "Kal",

  [LangKeys.reminders_chip_today]: "Aaj",

  [LangKeys.reminders_days_left]: "days left",

  [LangKeys.reminders_days_overdue]: "days late",

  [LangKeys.reminders_not_sent]: "Abhi tak nahi bheja gaya",

  [LangKeys.reminders_last_sent]: "Last sent",

  [LangKeys.reminders_auto_reminder_desc]: "Scheduled date aur time par apne aap reminder bhejein",

  [LangKeys.reminders_auto_reminder]: "Auto Reminder (Auto Send)",

  [LangKeys.reminders_send_all_whatsapp]: "Sabhi ko WhatsApp bhejein",

  [LangKeys.reminders_send_whatsapp]: "WhatsApp Reminder Bhejein",

  [LangKeys.reminders_change_due_date]: "Date Badlein",

  [LangKeys.reminders_set_due_date]: "Due Date Set Karein",

  [LangKeys.reminders_selected]: "Selected",

  [LangKeys.reminders_select_all]: "Select All",

  [LangKeys.reminders_search_hint]: "Customer name ya mobile search karein...",

  [LangKeys.reminders_no_date_tab]: "No Date",

  [LangKeys.reminders_upcoming_tab]: "Upcoming",

  [LangKeys.reminders_overdue_tab]: "Overdue",

  [LangKeys.reminders_today_tab]: "Today",

  [LangKeys.reminders_all_tab]: "All",

  [LangKeys.reminders_no_date]: "No Date",

  [LangKeys.reminders_upcoming]: "Upcoming",

  [LangKeys.reminders_due_today]: "Due Today",

  [LangKeys.reminders_overdue]: "Overdue",

  [LangKeys.reminders_total_outstanding]: "Total Outstanding",

  [LangKeys.reminders_subtitle]: "Smart khata ke saath apna business badhayein.",

  [LangKeys.reminders_title]: "Payment Reminder",

  [LangKeys.processing]: "Processing...",

  [LangKeys.business_owner]: "Business Owner",

  [LangKeys.moxpal_khata]: "Moxpal Khata",

  [LangKeys.failed_load_dashboard]: "Dashboard data load nahi ho paya",

  [LangKeys.delete_confirm]: "Kya aap delete karna chahte hain?",

  [LangKeys.today]: "Aaj",

  [LangKeys.add_bill_terms_conditions_hint]: "Terms & Conditions...",

  [LangKeys.stock]: "Stock",

  [LangKeys.add_bill_item_price]: "Price",

  [LangKeys.add_bill_item_name]: "Item Ka Naam",

  [LangKeys.parties]: "Parties",

  [LangKeys.address_area]: "Area / Landmark",

  [LangKeys.address_flat_no]: "Flat / Shop No.",

  [LangKeys.search_items_hint]: "Item search karein...",

  [LangKeys.no_items_found]: "Koi item nahi mila",

  [LangKeys.loading]: "Loading...",

  [LangKeys.edit_price_dialog_title]: "Price Edit Karein",

  [LangKeys.photos]: "Photos",

  [LangKeys.notes]: "Notes",

  [LangKeys.save_expense]: "Kharcha Save Karein",

  [LangKeys.add_bill_payment_details]: "Payment Details",

  [LangKeys.fields]: "Fields",

  [LangKeys.unpaid]: "Unpaid",

  [LangKeys.item_name_required]: "Item name zaroori hai",

  [LangKeys.delete_confirmation]: "Kya aap ise delete karna chahte hain?",

  [LangKeys.online_private]: "Private",

  [LangKeys.online_active]: "Online Market mein Live",

  [LangKeys.app_name]: 'Moxpal Khata',
  [LangKeys.header_subtitle]: "Smart bookkeeping ke saath apna business grow karein.",

  // SHARED KHATA
  [LangKeys.shared_khata__summary]: 'Khata Summary',
  [LangKeys.customer_name]: 'Customer Name',
  [LangKeys.mobile_no]: 'Mobile No',
  [LangKeys.transaction_history]: 'Transaction History',
  [LangKeys.total_debit]: 'Total Debit',
  [LangKeys.total_credit]: 'Total Credit',
  [LangKeys.net_balance]: 'Net Balance',
  [LangKeys.date]: 'Date',
  [LangKeys.credit]: 'Credit',
  [LangKeys.debit]: 'Debit',
  [LangKeys.balance]: 'Balance',
  [LangKeys.note]: 'Note',
  [LangKeys.call_support]: 'Support ko call karein',
  [LangKeys.invalid_link]: 'Yeh link invalid hai ya expire ho chuki hai.',
  [LangKeys.footer]: 'Yeh computer se banaya gaya statement hai aur ismein signature ki zaroorat nahi hai.',

  // COMMON
  [LangKeys.settings]: 'Settings',
  [LangKeys.settings_subtitle]: 'Apne application aur business preferences manage karein',
  [LangKeys.language]: 'Language',
  [LangKeys.select_language]: 'Bhasha chunein',
  [LangKeys.close]: 'Band karein',
  [LangKeys.save]: 'Save karein',
  [LangKeys.retry]: 'Dobara try karein',
  [LangKeys.profile]: 'Edit Profile',
  [LangKeys.logout]: 'Logout',
  [LangKeys.version]: 'Version',
  [LangKeys.copyright]: 'Copyright © Moxpal Khata',
  [LangKeys.total]: "Total",
  [LangKeys.required_field]: "Ye field required hai",
  [LangKeys.product]: "Product",

  [LangKeys.message_language]: "SMS Language",
  [LangKeys.follow_app]: "Follow App",

  [LangKeys.hindi]: "Hindi",
  [LangKeys.english]: "English",
  [LangKeys.hinglish]: "Hinglish",

  [LangKeys.gujarati]: "Gujarati",
  [LangKeys.marathi]: "Marathi",
  [LangKeys.punjabi]: "Punjabi",
  [LangKeys.tamil]: "Tamil",
  [LangKeys.telugu]: "Telugu",

  // SETTINGS PAGE
  [LangKeys.business_settings]: 'Business Settings',
  [LangKeys.business_settings_desc]: 'Business profile, logo aur GST details',
  [LangKeys.staff_permissions]: 'Staff & Permissions',
  [LangKeys.staff_permissions_desc]: 'Staff access aur permissions manage karein',
  [LangKeys.backup_information]: 'Backup Information',
  [LangKeys.backup_information_desc]: 'Khata data export aur restore karein',
  [LangKeys.delete_khata]: 'Khata Delete Karein',
  [LangKeys.delete_khata_desc]: 'Saara business data hamesha ke liye hatayein',
  [LangKeys.app_update]: 'App Update',
  [LangKeys.app_update_desc]: 'Latest version ke liye check karein',
  [LangKeys.app_up_to_date]: "App up to date hai",
  [LangKeys.failed_to_check_for_update]: "Update check karne mein problem hui",
  [LangKeys.whatsapp_service]: "WhatsApp Alerts & Credits",
  [LangKeys.whatsapp_service_desc]: "Customers ko automatic payment reminder bheje aur credits manage kare",

  /* ================= Whatsapp SMS Credtits PAGE ================= */
  [LangKeys.whatsapp_credits]: 'WhatsApp Credits',
  [LangKeys.available_credits]: 'Available Credits',
  [LangKeys.whatsapp_balance]: 'WhatsApp message balance',
  [LangKeys.used]: 'Used',
  [LangKeys.credits]: 'Credits',
  [LangKeys.proceed_to_pay]: 'Pay Kare',
  [LangKeys.recharge_plans]: 'Recharge Plans',
  [LangKeys.off]: 'Band',
  [LangKeys.premium_unlimited_active]: 'Unlimited WhatsApp alerts active hain! 🎉',
  [LangKeys.premium_unlimited_desc]: 'Aap Moxpal Khata ke sabse best plan \'Premium Plan 98\' ke active member hain! Aapko unlimited auto WhatsApp aur SMS alerts bilkul free diye gaye hain.',

  [LangKeys.load_failed]: 'Load fail ho gaya',
  [LangKeys.toggle_failed]: 'Toggle fail ho gaya',
  [LangKeys.order_failed]: 'Order fail ho gaya',
  [LangKeys.payment_error]: 'Payment error aaya',
  [LangKeys.payment_failed]: 'Payment fail ho gaya',
  [LangKeys.verification_failed]: 'Verification fail ho gaya',
  [LangKeys.recharge_successful]: 'Recharge successful ho gaya',
  [LangKeys.total_purchased]: 'Total Liye Gaye',

  /* ================= BACKUP INFORMATION ================= */
  [LangKeys.backup_info_text]: 'Jab aapka phone internet se juda hota hai to aapka data automatically backup ho jaata hai. Agar aap phone format karte hain ya app delete karte hain, to bas apne registered number se dobara login karein. Aapka data automatically restore ho jaayega.',
  [LangKeys.last_backup_at]: 'Aakhri Backup',

  /* ================= DELETE / KHATA ================= */
  [LangKeys.delete_warning_text]: 'Aap is business ko delete karne jaa rahe hain. Aapka saara data recycle bin mein chala jaayega. Aap use 30 din ke andar restore kar sakte hain.',
  [LangKeys.delete_placeholder]: 'Confirm karne ke liye business ka naam type karein',
  [LangKeys.delete_button]: 'DELETE',
  [LangKeys.delete_name_mismatch]: 'Business ka naam match nahi kar raha.',

  // ================= KHATA =================
  [LangKeys.my_khata]: "Mera Khata",
  [LangKeys.search_customer]: "Customer search karein",
  [LangKeys.all_customers]: "All Customers",
  [LangKeys.no_customers_found]: "Koi customer nahi mila",
  [LangKeys.no_suppliers_found]: "Koi supplier nahi mila",
  [LangKeys.no_parties_found]: "Koi parties nahi mili",

  [LangKeys.just_now]: 'Abhi abhi',
  [LangKeys.min_ago]: '{value} min pehle',
  [LangKeys.hr_ago]: '{value} hr pehle',
  [LangKeys.day_ago]: '{value} din pehle',
  [LangKeys.month_ago]: '{value} month pehle',
  [LangKeys.year_ago]: '{value} year pehle',

  [LangKeys.settled]: 'Settled',
  [LangKeys.advance]: 'Advance',
  [LangKeys.due]: 'Due',
  [LangKeys.no_transactions]: 'Koi len den nahi',
  [LangKeys.no_entries_yet]: 'Abhi tak koi entry nahi',
  [LangKeys.new_label]: 'New',

  /* ================= DASHBOARD / HOME SCREEN ================= */
  [LangKeys.khata]: 'Ledger',
  [LangKeys.you_will_get]: 'Aapko Lene Hain',
  [LangKeys.you_will_give]: 'Aapko Dene Hain',
  [LangKeys.search_khata_entry]: 'Entry Search Karein',
  [LangKeys.recent_entries]: 'Haal ki Entries',
  [LangKeys.unknown_party]: 'Anjaan Party',
  [LangKeys.unknown_customer]: 'Anjaan Customer',
  [LangKeys.unknown]: 'Anjaan',

  // CUSTOMER LEDGER
  [LangKeys.ledger]: 'Ledger',
  [LangKeys.report]: 'Report',
  [LangKeys.reminder]: 'Reminder',
  [LangKeys.sms]: 'SMS',
  [LangKeys.whatsapp]: 'Whatsapp',
  [LangKeys.outstanding_balance]: "Baaki Balance",
  [LangKeys.total_balance]: 'Total Balance',
  [LangKeys.you_got]: 'Aapko Mile',
  [LangKeys.you_gave]: 'Aapne Diye',
  [LangKeys.entries]: 'Entries',
  [LangKeys.no_entries_found]: 'Koi entry nahi mili',
  [LangKeys.i_got]: 'Maine Liye',
  [LangKeys.i_gave]: 'Maine Diye',
  [LangKeys.you_got_caps]: 'AAPKO MILE',
  [LangKeys.you_gave_caps]: 'AAPNE DIYE',
  [LangKeys.wa_dear]: 'Priye',
  [LangKeys.wa_account_update]: 'Moxpal Khata se aapka account update yahan hai.',
  [LangKeys.total_due]: "Kul Bakaya Rashi",
  [LangKeys.view_full_account]: 'Poora Account Statement Dekhein',
  [LangKeys.failed_to_load_data]: 'Data load nahi ho paaya.',
  [LangKeys.could_not_open_whatsapp]: 'WhatsApp nahi khul paaya.',
  [LangKeys.could_not_open_sms]: 'SMS app nahi khul paaya.',
  [LangKeys.total_purchase]: "Total Purchase",
  [LangKeys.total_received]: "Total Prapt ",

  [LangKeys.entry_success]: 'Entry safal hui',
  [LangKeys.transaction_success]: 'Len-den safal hua',
  [LangKeys.done]: 'Poora hua',

  // ENTRY
  [LangKeys.entry_details]: 'Entry ki Details',
  [LangKeys.running_balance]: 'Running Balance',
  [LangKeys.share]: 'Share karein',
  [LangKeys.network_error]: 'Network Error',
  [LangKeys.copy_link]: 'Link copy karein',
  [LangKeys.delete_entry]: 'Entry delete karein',
  [LangKeys.delete_entry_confirm]: 'Kya aap sach mein is entry ko delete karna chahte hain?',
  [LangKeys.delete_entry_warning]: 'Is action ko undo nahi kiya ja sakta.',
  [LangKeys.edit_entry]: 'Entry edit karein',
  [LangKeys.invalid_entry]: 'Invalid Entry',
  [LangKeys.entry_not_found]: 'Entry nahi mili',
  [LangKeys.invalid_entry_type]: 'Invalid entry type',
  [LangKeys.invalid_amount]: 'Invalid amount',
  [LangKeys.invalid_date]: 'Invalid date',
  [LangKeys.photo_size_error]: 'Photo ka size 1MB se kam hona chahiye',
  [LangKeys.invalid_image_format]: 'Yeh photo format supported nahi hai. Kripya JPG, PNG ya WEBP photo select karein.',
  [LangKeys.photo_upload_failed]: 'Photo upload fail ho gaya',
  [LangKeys.update_failed]: 'Update fail ho gaya',
  [LangKeys.amount]: 'Amount',
  [LangKeys.photo_max]: 'Photo (Max 1MB)',
  [LangKeys.change_photo]: 'Photo badlein',
  [LangKeys.add_entry_title]: 'Entry jodein',
  [LangKeys.save_entry]: 'Entry save karein',
  [LangKeys.photo]: 'Photo',
  [LangKeys.amount_hint]: '₹ 0',
  [LangKeys.note_hint]: 'Optional note',
  [LangKeys.add_photo_label]: '📷 Photo jodein',
  [LangKeys.failed_to_add_entry]: 'Entry jodne mein fail ho gaye.',
  [LangKeys.image_too_large_4mb]: 'Image bahut badi hai. Kripya 4MB se kam ki image chunein.',
  [LangKeys.share_coming_soon]: 'Share feature jald hi aa raha hai!',
  [LangKeys.image_load_failed]: 'Image load nahi ho paayi',
  [LangKeys.select_date]: 'Taarikh chunein',
  [LangKeys.photo_max_2mb]: 'Photo (Max 2MB)',
  [LangKeys.add_to_cashbook]: "Cashbook mein bhi add karein",

  // PDF
  [LangKeys.owner_name]: 'Malik ka Naam',
  [LangKeys.customer_ledger_statement]: 'Customer Ledger Statement',
  [LangKeys.phone]: 'Phone',
  [LangKeys.opening_balance]: 'Opening Balance',
  [LangKeys.closing_balance]: 'Closing Balance',
  [LangKeys.transaction_details]: 'Transaction Details',
  [LangKeys.particulars]: 'Particulars',
  [LangKeys.credit_short]: 'Cr',
  [LangKeys.debit_short]: 'Dr',
  [LangKeys.generated_by]: 'Moxpal Khata dwara banaya gaya',
  [LangKeys.my_business]: 'Mera Business',
  [LangKeys.pdf_generation_error]: 'PDF banane mein error',
  [LangKeys.debit_minus]: 'Debit (-)',
  [LangKeys.credit_plus]: 'Credit (+)',
  [LangKeys.customer_report]: "Customer Report",
  [LangKeys.print_download]: "Print / Download",
  [LangKeys.total_get]: "Total Get",
  [LangKeys.total_give]: "Total Give",
  [LangKeys.report_for]: "Report for",
  [LangKeys.period]: "Period",
  [LangKeys.report_generated_by]: "{app} dwara generate ki gayi report",
  [LangKeys.all_time]: "All Time",
  [LangKeys.get]: "Get",
  [LangKeys.give]: "Give",
  [LangKeys.data_not_available_for_pdf]: "PDF ke liye data available nahi hai",

  // ACCOUNT
  [LangKeys.account]: 'Account',
  [LangKeys.add_business]: 'Business Details Jodein',
  [LangKeys.add_owner]: 'Malik ki Details Jodein',
  [LangKeys.business]: 'Business',
  [LangKeys.staff]: 'Staff',
  [LangKeys.items]: 'Items',
  [LangKeys.bills]: 'Bills',
  [LangKeys.dairy]: "Dairy",
  [LangKeys.cashbook]: 'Cashbook',
  [LangKeys.help_support]: 'Help & Support',
  [LangKeys.about_app]: 'Hamare baare mein',
  [LangKeys.invite_friends]: 'Dosto ko invite karein',
  [LangKeys.privacy_policy]: 'Privacy Policy',
  [LangKeys.disclaimer]: 'Disclaimer',
  [LangKeys.share_subject]: "📒 Moxpal Khata App",
  [LangKeys.share_message]: "👉 Udhar-len den aur hisaab rakhne ke liye main Moxpal Khata app use kar raha hoon. Yeh bahut simple aur reliable app hai. 📲 Aap bhi abhi download karein aur apne khate aasani se manage karein: https://khata.moxpal.com/app",

  // STAFF
  [LangKeys.staff_details]: 'Staff ki Details',
  [LangKeys.staff_question]: 'Staff kya hai?',
  [LangKeys.add_staff]: 'Staff Jodein',
  [LangKeys.staff_name]: 'Staff ka Naam',
  [LangKeys.permissions]: 'Permissions',
  [LangKeys.stop_staff]: 'Staff ko Rokein',
  [LangKeys.stop_staff_desc]: 'Yeh staff aapke business data ko access nahi kar paayega.',
  [LangKeys.delete_staff]: 'Staff ko Delete Karein',
  [LangKeys.delete_staff_desc]: 'Yeh staff hamesha ke liye delete ho jaayega.',
  [LangKeys.add_staff_to_manage]: "Manage karne ke liye staff add karein",

  // NAVBAR
  [LangKeys.home]: 'Home',
  [LangKeys.more]: "More",

  // ADD PARTY
  [LangKeys.add_party]: 'Party Jodein',
  [LangKeys.address_optional]: 'Address (Optional)',
  [LangKeys.gst_optional]: 'GSTIN (Optional)',
  [LangKeys.add_supplier]: 'Supplier Jodein',
  [LangKeys.name_required]: 'Naam zaroori hai',
  [LangKeys.edit]: 'Edit karein',

  // BOOK PROFILE
  [LangKeys.book_profile]: 'Book Profile',
  [LangKeys.personal_info]: 'Personal Info',
  [LangKeys.business_info]: 'Business Info',
  [LangKeys.financial_info]: 'Financial Info',
  [LangKeys.staff_info]: 'Staff Info',
  [LangKeys.name]: 'Naam',
  [LangKeys.add_name]: 'Naam Jodein',
  [LangKeys.registered_number]: 'Registered Mobile Number',
  [LangKeys.add_mobile]: 'Mobile Number Jodein',
  [LangKeys.business_name]: 'Business ka Naam',
  [LangKeys.business_address]: 'Business ka Address',
  [LangKeys.add_address]: 'Address Jodein',
  [LangKeys.gstin]: 'GSTIN',
  [LangKeys.bank_account]: 'Bank Account',
  [LangKeys.add_details]: 'Details Jodein',
  [LangKeys.details]: 'Details',
  [LangKeys.add_photo]: "Photo add karein",
  [LangKeys.profile_strength]: "Profile Strength",
  [LangKeys.customer_profile]: "Customer Profile",
  [LangKeys.supplier_profile]: "Supplier Profile",
  [LangKeys.address]: "Address",
  [LangKeys.type]: "Type",
  [LangKeys.customer]: "Customer",
  [LangKeys.supplier]: "Supplier",
  [LangKeys.delete_customer]: "Customer delete karein",
  [LangKeys.delete_supplier]: "Supplier delete karein",
  [LangKeys.delete_customer_desc]: "Kya aap is customer ko delete karna chahte hain? Isse related saara data remove ho jayega.",
  [LangKeys.delete_supplier_desc]: "Kya aap is supplier ko delete karna chahte hain? Isse related saara data remove ho jayega.",
  [LangKeys.add_gstin]: "GSTIN add karein",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.sms_settings]: "SMS Settings",
  [LangKeys.sms_settings_desc]: "Is customer ke liye message settings manage karein",
  [LangKeys.edit_customer_details]: "Customer Details Edit Karein",
  [LangKeys.edit_customer_details_desc]: "Yahan aap naam, mobile, address aur GST details change kar sakte hain.",

  // PROFILE STRENGTH
  [LangKeys.weak]: 'Kamzor',
  [LangKeys.average]: 'Average',
  [LangKeys.good]: 'Accha',
  [LangKeys.strong]: 'Mazboot',

  // STAFF & PERMISSIONS
  [LangKeys.save_staff]: 'Staff Save Karein',
  [LangKeys.update_staff]: 'Staff Update Karein',
  [LangKeys.cancel]: 'Cancel',
  [LangKeys.no_staff_found]: 'Koi staff nahi mila',
  [LangKeys.active]: 'Active',
  [LangKeys.stopped]: 'Roka gaya',
  [LangKeys.start]: 'Shuru karein',
  [LangKeys.stop]: 'Rokein',
  [LangKeys.view]: 'Dekhein',
  [LangKeys.add]: 'Jodein',
  [LangKeys.delete]: 'Delete karein',
  [LangKeys.mobile_number]: 'Mobile Number',
  [LangKeys.add_staff_title]: 'Staff Jodein',
  [LangKeys.edit_staff_title]: 'Staff Edit Karein',
  [LangKeys.staff_deleted_success]: 'Staff safaltapoorvak delete ho gaya',
  [LangKeys.yes]: 'Haan',
  [LangKeys.no]: 'Nahi',
  [LangKeys.khatabook_deleted_success]: 'Khatabook safaltapoorvak delete ho gayi',
  [LangKeys.something_went_wrong]: 'Kuch galat ho gaya',
  [LangKeys.business_logo]: 'Business Logo',
  [LangKeys.choose_photo]: 'Photo Chunein',
  [LangKeys.save_logo]: 'Logo Save Karein',
  [LangKeys.upload_error]: 'Upload Error',
  [LangKeys.upload_type_err]: 'Upload type error',
  [LangKeys.enter_name]: 'Naam daalein',
  [LangKeys.enter_mobile]: 'Mobile daalein',
  [LangKeys.enter_business]: 'Business daalein',
  [LangKeys.enter_address]: 'Address daalein',
  [LangKeys.gstin_details]: 'GSTIN Details',
  [LangKeys.gstin_number]: 'GSTIN Number',
  [LangKeys.enter_gstin]: 'GSTIN daalein',
  [LangKeys.gstin_note]: 'Aapka GSTIN aapke business ko verify karne aur invoices banane ke liye istemal hota hai.',
  [LangKeys.save_gstin]: 'GSTIN Save Karein',
  [LangKeys.bank_details]: 'Bank Details',
  [LangKeys.bank_name]: 'Bank ka Naam',
  [LangKeys.enter_bank_name]: 'Bank ka naam daalein',
  [LangKeys.account_number]: 'Account Number',
  [LangKeys.enter_account_no]: 'Account number daalein',
  [LangKeys.ifsc_code]: 'IFSC Code',
  [LangKeys.enter_ifsc]: 'IFSC code daalein',
  [LangKeys.bank_note]: 'Aapka bank account payments receive karne ke liye istemal hota hai.',
  [LangKeys.save_bank_details]: 'Bank Details Save Karein',
  [LangKeys.invalid_bank_details]: 'Invalid bank details',
  [LangKeys.confirm]: 'Confirm',
  [LangKeys.invalid_gstin]: 'Invalid GSTIN',
  [LangKeys.failed_to_save]: 'Save nahi ho paaya',

  // Cashbook
  [LangKeys.cash]: "Cash",
  [LangKeys.online]: "Online",
  [LangKeys.total_balance_cashbook]: "Total baki rashi",
  [LangKeys.today_balance]: "Aaj ka Balance",
  [LangKeys.view_report]: "Report Dekhein",
  [LangKeys.out_entry]: "OUT",
  [LangKeys.in_entry]: "IN",
  [LangKeys.add_first_entry]: "Apni pehli entry jodein",
  [LangKeys.attach_bill]: "Bill jodein",
  [LangKeys.enter_amount]: "Amount daalein",
  [LangKeys.empty_title]: "Abhi tak koi entry nahi hai",
  [LangKeys.saving]: "Saving...",
  [LangKeys.save_failed]: "Save nahi ho paaya",
  [LangKeys.server_error]: "Server Error",
  [LangKeys.ok]: "OK",
  [LangKeys.error]: "Error",
  [LangKeys.payment_mode]: "Payment Mode",
  [LangKeys.entry_saved_offline_and_will_be_synced_later]: "Entry offline save ho gayi hai. Internet aate hi sync ho jayegi",
  [LangKeys.entry_waiting_to_be_synced]: "Entry offline save hai, sync pending hai",
  [LangKeys.cash_in]: 'Jama kiya gaya',
  [LangKeys.cash_out]: 'Nikasi ki gayi',
  [LangKeys.cashbook_status]: "Cashbook Status",
  [LangKeys.real_time_cash_online]: "Real-time Cash aur Online",

  // NEW Cashbook Specific keys
  [LangKeys.entry_is_backed_up]: "Entry backup ho gayi hai",
  [LangKeys.safe_and_secure]: "100% Safe aur Secure",
  [LangKeys.invalid_image_format_cashbook_popup]: "Unsupported format. Kripya JPG, PNG, ya WEBP ka istemal karein.",
  [LangKeys.photo_size_error_cashbook_popup]: "File bahut badi hai (Max 4MB)",
  [LangKeys.selected_image]: "Chuna gaya",

  // Cashbook Report Screen keys
  [LangKeys.cashbook_report_title]: "Cashbook Report",
  [LangKeys.date_range]: "Date Range",
  [LangKeys.single_day]: "Ek Din",
  [LangKeys.this_week]: "Is Hafte",
  [LangKeys.this_month]: "Is Mahine",
  [LangKeys.last_week]: "Pichle Hafte",
  [LangKeys.last_month]: "Pichle Mahine",
  [LangKeys.all]: "Sabhi",
  [LangKeys.to]: "se",
  [LangKeys.no_entries_found_period]: "Is dauraan koi entry nahi mili.",
  [LangKeys.daily_balance_short]: "Rojana Balance",
  [LangKeys.download_pdf]: "DOWNLOAD PDF",
  [LangKeys.pdf_download_not_implemented]: "PDF Download abhi tak lagu nahi kiya gaya hai.",

  // Cashbook Report Day Screen keys
  [LangKeys.daily_details]: "Rojana Details",
  [LangKeys.no_entries_on_this_day]: "Is din koi entry nahi hai",
  [LangKeys.add_entries_help]: "Entries jodein unhein yahan dekhne ke liye.",
  [LangKeys.add_entry_to]: "Entry Jodein",
  [LangKeys.add_entry]: "Entry Jodein",
  [LangKeys.could_not_load_report]: "Report load nahi ho paayi.",

  // NEW Entry Details Screen specific keys
  [LangKeys.delete_failed]: "Delete fail ho gaya",
  [LangKeys.photo_max_4mb]: "Photo (Max 4MB)",
  [LangKeys.entry_of_amount]: "ki Entry ",

  // PDF CASHBOOK REPORT
  [LangKeys.daily_summary]: "Rojana Summary",
  [LangKeys.total_in]: "Total In",
  [LangKeys.total_out]: "Total Out",
  [LangKeys.no_data_available]: "Koi data uplabdh nahi hai",

  // Months (for date formatting)
  [LangKeys.month_1]: "Jan",
  [LangKeys.month_2]: "Feb",
  [LangKeys.month_3]: "Mar",
  [LangKeys.month_4]: "Apr",
  [LangKeys.month_5]: "May",
  [LangKeys.month_6]: "Jun",
  [LangKeys.month_7]: "Jul",
  [LangKeys.month_8]: "Aug",
  [LangKeys.month_9]: "Sep",
  [LangKeys.month_10]: "Oct",
  [LangKeys.month_11]: "Nov",
  [LangKeys.month_12]: "Dec",

  // NEW Customer Supplier Add
  [LangKeys.add_customer]: "Customer Jodein",
  [LangKeys.customer_already_exists]: 'Customer pehle se exist karta hai',
  [LangKeys.supplier_already_exists]: 'Supplier pehle se exist karta hai',

  // ✅ NEW CASHBOOK EMPTY STATE
  [LangKeys.cashbook_welcome]: "Hello! Chaliye aaj ki entries karte hain",
  [LangKeys.add_first_entry_btn]: "Apni Pehli Entry Jodein",

  // ✅ NEW KEY FOR EMPTY STATE TEXT
  [LangKeys.add_customers_collect_faster]: "Grahakon ko jode aur bhugtan prapt Karen",

  // ✅ NEW KEYS FOR PERMISSIONS
  [LangKeys.permission_denied_title]: "Permission Denied",
  [LangKeys.permission_denied_content]: "Photo access permanently deny ho chuka hai. Please app settings me jaakar ise enable karein.",
  [LangKeys.permission_denied_settings_button]: "Open Settings",
  [LangKeys.permission_denied_cancel_button]: "Cancel",
  [LangKeys.permission_denied_generic_message]: "Permission denied. Photo select karne ke liye photo access allow karein.",

  // Contact Picker
  [LangKeys.permission_required]: "Permission Required",
  [LangKeys.contacts_permission_message]: "Contact pick karne ke liye Contacts permission chahiye. Please app settings me jaakar enable karein.",
  [LangKeys.failed_to_open_contacts_picker]: "Contacts picker open nahi ho paaya.",
  [LangKeys.permission_denied_to_read_contacts]: "Contacts read karne ki permission deny ho gayi.",

  // ================= ADD ITEM SCREEN =================
  [LangKeys.tax_exempted]: "Tax Exempted",
  [LangKeys.no_gst]: "No GST",
  [LangKeys.select_photo]: "Photo Select karein",
  [LangKeys.gallery]: "Gallery",
  [LangKeys.camera]: "Camera",
  [LangKeys.please_enter_item_name]: "Please item ka naam enter karein",
  [LangKeys.failed_to_upload_image]: "Image upload nahi ho payi",
  [LangKeys.item_updated_successfully]: "Item successfully update ho gaya",
  [LangKeys.item_saved_successfully]: "Item successfully save ho gaya",
  [LangKeys.failed_to_update_item]: "Item update nahi ho paya",
  [LangKeys.failed_to_save_item]: "Item save nahi ho paya",
  [LangKeys.confirm_deletion]: "Delete Confirm karein",
  [LangKeys.are_you_sure_delete_item]: "Kya aap is item ko delete karna chahte hain?",
  [LangKeys.item_deleted_successfully]: "Item successfully delete ho gaya",
  [LangKeys.failed_to_delete_item]: "Item delete nahi ho paya",
  [LangKeys.edit_item]: "Item Edit karein",
  [LangKeys.edit_service]: "Service Edit karein",
  [LangKeys.add_product]: "Product Add karein",
  [LangKeys.add_service]: "Service Add karein",
  [LangKeys.add_hsn_and_gst_details]: "HSN & GST details add karein",
  [LangKeys.hsn]: "HSN",
  [LangKeys.enter_hsn]: "HSN enter karein",
  [LangKeys.gst_rate_percent]: "GST Rate (%)",
  [LangKeys.enter_gst_rate]: "GST rate enter karein",
  [LangKeys.primary_unit]: "Primary Unit",
  [LangKeys.enter_item_name_here]: "Yahan item ka naam likhein",
  [LangKeys.sale_price]: "Sale Price",
  [LangKeys.purchase_price]: "Purchase Price",
  [LangKeys.tax_included]: "Tax included hai",
  [LangKeys.opening_stock]: "Opening Stock",
  [LangKeys.low_stock_alert]: "Low Stock Alert",
  [LangKeys.as_of_date]: "As of date",
  [LangKeys.enter_price]: "Price enter karein",
  [LangKeys.enter_count]: "Quantity enter karein",
  [LangKeys.save_item]: "Item Save karein",
  [LangKeys.delete_item]: "Item Delete karein",
  [LangKeys.select_unit]: "Unit select karein",
  [LangKeys.search_unit]: "Unit search karein",
  [LangKeys.add_gst_rate]: "GST rate add karein",
  [LangKeys.add_custom_tax]: "Custom tax add karein",
  [LangKeys.custom_tax]: "Custom Tax",
  [LangKeys.gst]: "GST",
  [LangKeys.cess]: "Cess",
  [LangKeys.add_hsn_code]: "HSN code add karein",
  [LangKeys.hsn_code]: "HSN Code",
  [LangKeys.item_name]: "Item Name",
  [LangKeys.enter_hsn_code]: "HSN code enter karein",
  [LangKeys.enter_item_name]: "Item name enter karein",
  [LangKeys.results]: "Results",
  [LangKeys.no_hsn_code_found]: "Koi HSN code nahi mila",
  [LangKeys.use]: "Use karein",
  [LangKeys.as_hsn_code]: "HSN code ke roop mein",
  [LangKeys.you_are_offline_please_connect_to_the_internet]: "Aap offline hain. Kripya internet se connect karein.",

  // ================= ITEMS SCREEN =================
  [LangKeys.products]: "Products",
  [LangKeys.services]: "Services",
  [LangKeys.add_product_caps]: "ADD PRODUCT",
  [LangKeys.add_service_caps]: "ADD SERVICE",
  [LangKeys.add_items_and_get_started]: "Apni inventory manage karna shuru karein",
  [LangKeys.manage_stock_feature]: "Apne business ke liye smart stock control",
  [LangKeys.detailed_stock_history_feature]: "Item activity ka complete record dekhein",
  [LangKeys.track_prices_and_profits_feature]: "Pricing aur profit margin ko aasani se monitor karein",

  [LangKeys.search_items]: "Items search karein",
  [LangKeys.my_items]: "My Items",
  [LangKeys.item_added]: "Item Added",
  [LangKeys.low_stock]: "Low Stock",
  [LangKeys.current_stock]: "Current Stock",
  [LangKeys.stock_history]: "Stock History",
  [LangKeys.stock_in]: "IN",
  [LangKeys.stock_out]: "OUT",
  [LangKeys.add_services_and_get_started]: "Apni services manage karna shuru karein",
  [LangKeys.manage_services_feature]: "Apni sabhi service offerings ko organize aur manage karein",
  [LangKeys.save_sac_and_gst_feature]: "SAC code aur GST details aasani se save karein",
  [LangKeys.track_sales_and_bills_feature]: "Service sales aur billing records ko track karein",

  [LangKeys.net_monthly_sales]: "Net Monthly Sales",
  [LangKeys.rupees]: "Rupees",
  [LangKeys.search_services]: "Services search karein",
  [LangKeys.my_services]: "My Services",
  [LangKeys.service_price]: "Service Price",
  [LangKeys.unit]: "Unit",
  [LangKeys.enter_purchased_quantity]: "Purchased quantity enter karein",
  [LangKeys.enter_sold_quantity]: "Sold quantity enter karein",
  [LangKeys.quantity]: "Quantity",
  [LangKeys.add_notes_optional]: "Notes add karein (optional)",
  [LangKeys.stock_in_caps]: "STOCK IN",
  [LangKeys.stock_out_caps]: "STOCK OUT",
  [LangKeys.total_stock]: "Total Stock",
  [LangKeys.low_stock_items]: "Low Stock Wale Items",
  [LangKeys.all_items]: "All Items",
  [LangKeys.failed_to_load_items]: "Items load nahi ho paaye",


  // ================= ITEMS SALES REPORT SCREEN =================

  [LangKeys.item_sales_report]: "Item Sales Report",
  [LangKeys.total_qty_sold]: "Total Qty Sold",
  [LangKeys.units]: "Units",
  [LangKeys.nos]: "NOS",
  [LangKeys.sold]: "Sold",
  [LangKeys.bought]: "Bought",
  [LangKeys.profit]: "Profit",
  [LangKeys.loss]: "Loss",

  // Filter & Sort
  [LangKeys.filter_by_stock]: "Stock ke hisaab se Filter karo",
  [LangKeys.sort_by_name_az]: "Naam A se Z tak",
  [LangKeys.sort_by_name_za]: "Naam Z se A tak",

  // ================= ADD SERVICE SCREEN =================
  [LangKeys.failed_to_process_image]: "Image process nahi ho payi",
  [LangKeys.could_not_pick_image]: "Image select nahi ho payi",
  [LangKeys.failed_to_upload_photo]: "Photo upload nahi ho payi",
  [LangKeys.failed_to_update_service]: "Service update nahi ho payi",
  [LangKeys.failed_to_add_service]: "Service add nahi ho payi",
  [LangKeys.are_you_sure_delete_service]: "Kya aap is service ko delete karna chahte hain?",
  [LangKeys.failed_to_delete_service]: "Service delete nahi ho payi",
  [LangKeys.add_sac_and_gst_details]: "SAC & GST details add karein",
  [LangKeys.sac_code]: "SAC Code",
  [LangKeys.enter_sac]: "SAC enter karein",
  [LangKeys.enter_service_name_here]: "Yahan service ka naam likhein",
  [LangKeys.please_enter_service_name]: "Please service ka naam enter karein",
  [LangKeys.tax_included_in_price]: "Price mein tax included hai",
  [LangKeys.delete_service]: "Service Delete karein",
  [LangKeys.save_changes]: "Changes Save karein",

  // ================= ITEM DETAILS SCREEN =================
  [LangKeys.edit_product]: "Product Edit karein",
  [LangKeys.stock_quantity]: "Stock Quantity",
  [LangKeys.stock_value]: "Stock Value",

  // ================= SERVICE DETAILS SCREEN =================
  [LangKeys.edit_service_caps]: "EDIT SERVICE",
  [LangKeys.service_name]: "Service Name",
  [LangKeys.gst_percent]: "GST %",
  [LangKeys.no_sales_added_for_service]: "Is service ke liye koi sales add nahi hui",
  [LangKeys.zero_percent]: "0%",

  /* ================= BILLS SCREEN ================= */
  [LangKeys.bills_add_sale]: "Sale Add karein",
  [LangKeys.bills_search_sales_hint]: "Sales search karein",
  [LangKeys.bills_add_purchase]: "Purchase Add karein",
  [LangKeys.bills_search_purchases_hint]: "Purchases search karein",
  [LangKeys.bills_add_expense]: "Expense Add karein",
  [LangKeys.bills_search_expenses_hint]: "Expenses search karein",
  [LangKeys.bills_start_creating_gst]: "Instant GST bills banana shuru karein",
  [LangKeys.bills_tab_sale]: "Sale",
  [LangKeys.bills_tab_purchase]: "Purchase",
  [LangKeys.bills_tab_expense]: "Expense",
  [LangKeys.bills_monthly_sales]: "Monthly Sales",
  [LangKeys.bills_monthly_purchases]: "Monthly Purchases",
  [LangKeys.bills_view_reports]: "Reports dekhein",
  [LangKeys.bills_todays_in]: "Aaj ki Income",
  [LangKeys.bills_todays_out]: "Aaj ka Expense",
  [LangKeys.bills_cashbook]: "Cashbook",
  [LangKeys.bills_empty_state_title]: "Professional Invoices turant banayein",
  [LangKeys.bills_empty_state_subtitle]: "Ledger, Stock aur Cashbook auto update hote hain",
  [LangKeys.bills_empty_state_gst_support]: "GST aur Non-GST dono billing supported",
  [LangKeys.bills_see_sample_invoices]: "Sample invoices dekhein",
  [LangKeys.bills_no_matching_found]: "Koi matching bill nahi mila",
  [LangKeys.bills_payment_in]: "Payment In",
  [LangKeys.bills_status_fully_paid]: "Fully Paid",
  [LangKeys.bills_status_unpaid]: "Unpaid",
  [LangKeys.bills_sale_bill]: "Sale Bill",
  [LangKeys.bills_purchase_bill]: "Purchase Bill",
  [LangKeys.bills_expense_bill]: "Expense",
  [LangKeys.bills_more_button]: "More",
  [LangKeys.bills_added_to_ledger]: "✓ Khate me joda gaya",

  // ================= FILTER & SORT =================
  [LangKeys.filter_and_sort]: "Filter & Sort",
  [LangKeys.filter_by_status]: "Status se Filter karo",
  [LangKeys.filter_all_bills]: "Sabhi Bills",
  [LangKeys.filter_paid_bills]: "Paid Bills",
  [LangKeys.filter_unpaid_bills]: "Unpaid Bills",
  [LangKeys.sort_by]: "Sort karo",
  [LangKeys.sort_latest_first]: "Latest pehle",
  [LangKeys.sort_oldest_first]: "Purane pehle",
  [LangKeys.sort_highest_amount]: "Sabse zyada amount",
  [LangKeys.sort_lowest_amount]: "Sabse kam amount",
  [LangKeys.clear_filters]: "Filter hatao",
  [LangKeys.apply_filters]: "Filter apply karo",

  /* ================= ADD BILL SCREEN ================= */
  [LangKeys.add_bill_sale]: "Sale",
  [LangKeys.add_bill_purchase]: "Purchase",
  [LangKeys.add_bill_expense]: "Expense",
  [LangKeys.add_bill_edit_sale_gst_bill]: "Sale GST Bill edit karein",
  [LangKeys.add_bill_sale_gst_bill]: "Sale GST Bill",
  [LangKeys.add_bill_edit_purchase_gst_bill]: "Purchase GST Bill edit karein",
  [LangKeys.add_bill_purchase_gst_bill]: "Purchase GST Bill",
  [LangKeys.add_bill_edit_expense]: "Expense edit karein",
  [LangKeys.add_bill_expense_title]: "Expense",
  [LangKeys.add_bill_edit_sale_bill]: "Sale Bill edit karein",
  [LangKeys.add_bill_sale_bill]: "Sale Bill",
  [LangKeys.add_bill_edit_purchase_bill]: "Purchase Bill edit karein",
  [LangKeys.add_bill_purchase_bill]: "Purchase Bill",
  [LangKeys.add_bill_sale_bill_no]: "Sale Bill No.",
  [LangKeys.add_bill_purchase_bill_no]: "Purchase Bill No.",
  [LangKeys.add_bill_expense_no]: "Expense No.",
  [LangKeys.add_bill_update_sale_bill]: "Sale Bill update karein",
  [LangKeys.add_bill_generate_sale_bill]: "Sale Bill generate karein",
  [LangKeys.add_bill_update_purchase_bill]: "Purchase Bill update karein",
  [LangKeys.add_bill_generate_purchase_bill]: "Purchase Bill generate karein",
  [LangKeys.add_bill_update_expense]: "Expense update karein",
  [LangKeys.add_bill_generate_expense]: "Expense add karein",
  [LangKeys.add_bill_select_customer_error]: "Please customer select karein",
  [LangKeys.add_bill_add_item_error]: "Kam se kam ek item add karein",
  [LangKeys.add_bill_updated_successfully]: "Successfully update ho gaya",
  [LangKeys.add_bill_saved_successfully]: "Successfully save ho gaya",
  [LangKeys.add_bill_failed_to_save]: "Bill save nahi ho paya",
  [LangKeys.add_bill_error_occurred]: "Kuch galat ho gaya",
  [LangKeys.add_bill_bill_to]: "Bill To",
  [LangKeys.add_bill_search_parties]: "Parties search karein",
  [LangKeys.add_bill_add_new_party]: "New Party add karein",
  [LangKeys.add_bill_edit_party_details]: "Party details edit karein",
  [LangKeys.add_bill_items]: "Items",
  [LangKeys.add_bill_enter_items_from_inventory]: "Inventory se items add karein",
  [LangKeys.add_bill_add_new_item]: "New Item add karein",
  [LangKeys.add_bill_n_items]: "{n} Items",
  [LangKeys.add_bill_edit_or_add_items]: "Items edit ya add karein",
  [LangKeys.add_bill_discount]: "Discount",
  [LangKeys.add_bill_extra_discount]: "Extra Discount",
  [LangKeys.add_bill_item_subtotal]: "Item Subtotal",
  [LangKeys.add_bill_round_off]: "Round Off",
  [LangKeys.add_bill_bill_amount]: "Bill Amount",
  [LangKeys.add_bill_optional_fields]: "Optional Fields",
  [LangKeys.add_bill_printed_on_invoice]: "Invoice par print hoga",
  [LangKeys.add_bill_custom_fields]: "Custom Fields",
  [LangKeys.add_bill_party_address]: "Party Address",
  [LangKeys.add_bill_your_address]: "Aapka Address",
  [LangKeys.add_bill_terms_conditions]: "Terms & Conditions",
  [LangKeys.add_bill_private_to_you]: "Sirf aapke liye",
  [LangKeys.add_bill_add_notes_photos]: "Notes ya photos add karein",
  [LangKeys.add_bill_n_photos_added]: "{n} photos add hue",
  [LangKeys.add_bill_balance_due]: "Balance Due",
  [LangKeys.cgst]: "CGST",
  [LangKeys.sgst]: "SGST",
  [LangKeys.pending_bill_no]: "Baki Bill No.",
  [LangKeys.add_bill_add_due_to_ledger]: "Ledger mein due balance jode",
  [LangKeys.add_bill_select_supplier_error]: "Kripya supplier chune",

  /* ================= BILL DETAILS SCREEN ================= */
  [LangKeys.bill_details_error_id_missing]: "Bill ID missing hai",
  [LangKeys.bill_details_failed_to_load]: "Bill load nahi ho paya",
  [LangKeys.bill_details_delete_confirmation_title]: "Bill delete karein",
  [LangKeys.bill_details_delete_confirmation_content]: "Kya aap waqai is bill ko delete karna chahte hain? Dhyan rahe ki bill se judi cashbook entry bhi delete ho jayegi.",
  [LangKeys.bill_details_delete_button]: "Delete",
  [LangKeys.bill_details_deleted_successfully]: "Bill successfully delete ho gaya",
  [LangKeys.bill_details_failed_to_delete]: "Bill delete nahi ho paya",
  [LangKeys.bill_details_generating_pdf]: "PDF generate ho rahi hai",
  [LangKeys.bill_details_share_text]: "Ye raha aapka bill",
  [LangKeys.bill_details_failed_to_share]: "Bill share nahi ho paya",
  [LangKeys.bill_details_title]: "Bill Details",
  [LangKeys.bill_details_could_not_load]: "Bill details load nahi ho payi",
  [LangKeys.bill_details_status]: "Status",
  [LangKeys.bill_details_status_pending]: "Pending",
  [LangKeys.bill_details_no_items]: "Koi item add nahi hai",
  [LangKeys.bill_details_view_pdf]: "PDF dekhein",

  /* ================= EXPENSE DETAILS SCREEN ================= */
  [LangKeys.expense_number_prefix]: "Expense #",
  [LangKeys.edit_expense]: "EDIT EXPENSE",
  [LangKeys.delete_expense]: "DELETE EXPENSE",
  [LangKeys.deleting_expense]: "DELETE ho raha hai...",
  [LangKeys.expense_deleted_successfully]: "Expense safalta se delete ho gaya",
  [LangKeys.failed_to_delete_expense]: "Expense delete karne me fail hua",
  [LangKeys.edit_feature_coming_soon]: "Edit feature jaldi aa raha hai!",
  [LangKeys.delete_expense_confirmation]: "Kya aap sure ho ki aap is expense ko delete karna chahte ho?",

  /* ================= INVOICE PREVIEW SCREEN ================= */
  [LangKeys.invoice_preview_title]: "Invoice Preview",
  [LangKeys.invoice_preview_generating]: "Invoice generate ho raha hai",
  [LangKeys.invoice_preview_failed]: "Invoice generate nahi ho paya",
  [LangKeys.invoice_preview_preparing_print]: "Print ke liye prepare ho raha hai",
  [LangKeys.invoice_preview_failed_print]: "Print nahi ho paya",
  [LangKeys.invoice_preview_delete_title]: "Invoice delete karein",
  [LangKeys.invoice_preview_delete_content]: "Kya aap is invoice ko delete karna chahte hain? Dhyan rahe ki isse judi cashbook entry bhi delete ho jayegi.",
  [LangKeys.invoice_preview_deleted_successfully]: "Invoice delete ho gaya",
  [LangKeys.invoice_preview_failed_delete]: "Invoice delete nahi ho paya",
  [LangKeys.invoice_preview_theme_premium]: "Premium",
  [LangKeys.invoice_preview_theme_thermal]: "Thermal",
  [LangKeys.invoice_preview_theme_basic]: "Basic",
  [LangKeys.invoice_preview_theme_new]: "New",
  [LangKeys.invoice_preview_download]: "Invoice Download",
  [LangKeys.invoice_preview_share]: "Invoice Share",
  [LangKeys.invoice_preview_print]: "Invoice Print",
  [LangKeys.invoice_preview_create_new]: "New Banayein",
  [LangKeys.invoice_preview_done]: "Done",

  /* ================= PAYMENT DETAILS SCREEN ================= */
  [LangKeys.payment_details_title_in]: "Payment In",
  [LangKeys.payment_details_title_out]: "Payment Out",
  [LangKeys.payment_details_share_text]: "Payment details",
  [LangKeys.payment_details_failed_to_share]: "Payment details share nahi ho paye",
  [LangKeys.payment_details_adjusted_invoices]: "Adjusted Invoices",

  /* ================= SAMPLE INVOICES SCREEN ================= */
  [LangKeys.sample_invoice_title]: "Sample",
  [LangKeys.premium_invoice]: "Premium Invoice",
  [LangKeys.thermal_invoice]: "Thermal Invoice",
  [LangKeys.basic_invoice]: "Basic Invoice",
  [LangKeys.use_this_template]: "USE THIS TEMPLATE",

  /* ================= ITEM SELECT SHEET ================= */
  [LangKeys.item_select_not_enough_stock]: "Enough stock nahi hai. Sirf {availableStock} available hai.",
  [LangKeys.item_select_no_items_found]: "Koi item nahi mila",
  [LangKeys.item_select_item_discount]: "Item Discount",
  [LangKeys.item_select_final_price]: "Final Price",
  [LangKeys.item_select_gst_rate]: "GST Rate",
  [LangKeys.item_select_item_single]: "Item",
  [LangKeys.item_select_item_plural]: "Items",
  [LangKeys.item_select_continue]: "Continue",
  [LangKeys.item_select_add_items_to_invoice]: "Invoice me items add karein",
  [LangKeys.item_select_search_created_items]: "Created items search karein",
  [LangKeys.item_select_add_new]: "ADD NEW",

  /* ================= QUICK ADD ITEM DIALOG ================= */
  [LangKeys.add_more_details]: "ADD MORE (STOCK, PURCHASE PRICE etc)",
  [LangKeys.add_item_to_bill]: "Bill me item add karein",
  [LangKeys.please_enter_value]: "Please value enter karein",
  [LangKeys.please_enter_valid_number]: "Please valid number enter karein",

  /* ================= CUSTOM FIELDS DIALOG ================= */
  [LangKeys.add_bill_custom_fields_subtitle]:
    "Maximum 5 custom fields add kar sakte hain (Eg- Serial Number, Batch, IMEI etc)",
  [LangKeys.add_bill_add_new_custom_field]: "ADD NEW CUSTOM FIELD",
  [LangKeys.add_bill_max_custom_fields]: "Aap maximum 5 custom fields hi add kar sakte hain.",
  [LangKeys.add_bill_custom_field_name_hint]: "Field Name",
  [LangKeys.add_bill_custom_field_value_hint]: "Value",

  /* ================= EDIT PRICE DIALOG ================= */
  [LangKeys.edit_price_gst_details]:
    "({cgst}% CGST + {sgst}% SGST; {igst}% IGST)",
  [LangKeys.edit_price_enter_discount_hint]: "Discount enter karein",
  [LangKeys.rupee]: "Rupee",
  [LangKeys.percentage]: "Percentage",
  [LangKeys.rate]: "Rate",
  [LangKeys.tax]: "Tax",

  /* ================= ADDRESS SCREEN ================= */
  [LangKeys.address_business_address_title]: "Business Address",
  [LangKeys.address_flat_building_number]: "Flat / Building Number",
  [LangKeys.address_enter_flat_building_number]: "Please Flat/Building Number enter karein",
  [LangKeys.address_area_locality]: "Area / Locality",
  [LangKeys.address_enter_area_locality]: "Please Area/Locality enter karein",
  [LangKeys.address_city]: "City",
  [LangKeys.address_enter_city]: "Please city enter karein",
  [LangKeys.address_state]: "State",
  [LangKeys.address_enter_state]: "Please state enter karein",
  [LangKeys.address_pincode]: "Pincode",
  [LangKeys.address_enter_pincode]: "Please Pincode enter karein",
  [LangKeys.address_invalid_pincode]: "Invalid pincode",

  /* ================= PARTY ADDRESS SCREEN ================= */
  [LangKeys.party_address_title]: "Customer Address",
  [LangKeys.party_address_billing_address]: "Billing Address",
  [LangKeys.party_address_shipping_same_as_billing]: "Shipping address billing jaisa hi hai",

  /* ================= ADD NOTES AND PHOTOS DIALOG ================= */
  [LangKeys.add_notes_and_photos_title]: "Notes & Photos add karein",
  [LangKeys.add_notes_and_photos_subtitle]: "Additional details ya images add karein",
  [LangKeys.add_notes_and_photos_notes_hint]: "Yahan notes likhein",
  [LangKeys.photos_access_permanently_denied]: "Photo access permanently denied hai. Please app settings me jaakar enable karein.",
  [LangKeys.photos_access_denied]: "Photo select karne ke liye, app ko camera ya photos access ki permission settings me allow karein.",
  [LangKeys.open_settings]: "Open Settings",

  /* ================= TERMS AND CONDITIONS DIALOG ================= */
  [LangKeys.terms_and_conditions_title]: "Terms & Conditions",
  [LangKeys.terms_and_conditions_hint]: "Terms aur conditions enter karein",

  // ================= KHATA TABS =================
  [LangKeys.customers]: "Customers",
  [LangKeys.suppliers]: "Suppliers",
  [LangKeys.search_supplier]: "Supplier search karein",
  [LangKeys.add_first_customer]: "Apna pehla customer add karein",
  [LangKeys.add_first_supplier]: "Apna pehla supplier add karein",
  [LangKeys.add_new_customer_prompt]: "Abhi tak koi customer add nahi hua hai. Naya customer add karne ke liye upar diye gaye “+” button par tap karein.",
  [LangKeys.add_new_suppliers_prompt]: "Abhi tak koi supplier add nahi hua hai. Naya supplier add karne ke liye upar diye gaye “+” button par tap karein.",

  // ================= CASHBOOK HELP DIALOG =================
  [LangKeys.cashbook_help_title]: "Cashbook Help",
  [LangKeys.cashbook_help_in_title]: "Cash In (Jama)",
  [LangKeys.cashbook_help_in_desc]: "Yahan aapke business mein receive hui sabhi cash entries ka record dikhaya jata hai.",
  [LangKeys.cashbook_help_out_title]: "Cash Out (Nikasi)",
  [LangKeys.cashbook_help_out_desc]: "Yahan aapke business se kharch hui sabhi cash entries ka record dikhaya jata hai.",
  [LangKeys.cashbook_help_total_balance_title]: "Total Balance",
  [LangKeys.cashbook_help_total_balance_desc]: "Yeh aapke cashbook ka current total balance dikhata hai.",
  [LangKeys.cashbook_help_today_balance_title]: "Aaj ka Balance",
  [LangKeys.cashbook_help_today_balance_desc]: "Yeh sirf aaj ki cash transactions ke base par balance dikhata hai.",
  [LangKeys.cashbook_help_report_title]: "Cashbook Report",
  [LangKeys.cashbook_help_report_desc]: "Yahan se aap cashbook report dekh aur download kar sakte hain.",

  // ✅ NEW KEYS FOR ADD EXPENSE SCREEN
  [LangKeys.expense_amount]: "Expense ki Rakam",
  [LangKeys.select_category]: "Category Select karein",
  [LangKeys.select_expense_category]: "Expense Category Select karein",
  [LangKeys.expense_items_warning]: "Expense items aapke inventory items ko affect nahi karenge.",
  [LangKeys.add_expense_items_optional]: "Expense Items Add karein (Optional)",
  [LangKeys.expense_items_feature_coming_soon]: "Expense Items feature jaldi aa raha hai!",
  [LangKeys.notes_and_photos_optional]: "Notes & Photos (Optional)",
  [LangKeys.photos_added]: "Photos add ho gaye",
  [LangKeys.save_expense_amount]: "EXPENSE SAVE karein",
  [LangKeys.update_expense_amount]: "EXPENSE UPDATE karein",
  [LangKeys.expense_saved_successfully]: "Expense successfully save ho gaya",
  [LangKeys.expense_updated_successfully]: "Expense successfully update ho gaya",
  [LangKeys.failed_to_save_expense]: "Expense save karne me problem aayi",
  [LangKeys.enter_valid_amount]: "Please valid amount enter karein.",
  [LangKeys.please_select_expense_category]: "Please expense category select karein.",
  [LangKeys.category]: "Category",

  // ===== EXPENSE CATEGORIES =====
  [LangKeys.cat_rent]: "Kiraya",
  [LangKeys.cat_salaries]: "Salary / Mazdoori",
  [LangKeys.cat_electricity]: "Bijli",
  [LangKeys.cat_water]: "Pani ka Bill",
  [LangKeys.cat_internet]: "Telephone / Internet",
  [LangKeys.cat_office]: "Office Kharcha",
  [LangKeys.cat_marketing]: "Marketing / Ads",
  [LangKeys.cat_travel]: "Travel",
  [LangKeys.cat_fuel]: "Fuel / Petrol",
  [LangKeys.cat_food]: "Khana / Refreshments",
  [LangKeys.cat_repairs]: "Repairs & Maintenance",
  [LangKeys.cat_election]: "Election Kharcha",
  [LangKeys.cat_taxes]: "Tax / GST",
  [LangKeys.cat_insurance]: "Insurance",
  [LangKeys.cat_cleaning]: "Safai",
  [LangKeys.cat_delivery]: "Delivery / Shipping",
  [LangKeys.cat_software]: "Software / Apps",
  [LangKeys.cat_furniture]: "Furniture",
  [LangKeys.cat_other]: "Other",

  // ================= EXPENSE EMPTY STATE =================
  [LangKeys.expense_empty_title]: "Apne expenses ko aasani se manage karein",
  [LangKeys.expense_empty_subtitle]: "Apne business ke sabhi kharche ek hi jagah track karein.",
  [LangKeys.expense_empty_footer]: "Sabhi expenses automatically cashbook me add ho jate hain.",

  // ================= BILL REPORT SCREEN =================
  [LangKeys.bill_report_title]: "Bill Report",
  [LangKeys.report_for_period]: "Is Period ka Report",
  [LangKeys.select_date_range]: "Date Range select karo",
  [LangKeys.total_sales]: "Total Sales",
  [LangKeys.total_purchases]: "Total Purchases",
  [LangKeys.total_expenses]: "Total Expenses",
  [LangKeys.net_profit]: "Net Profit",
  [LangKeys.net_loss]: "Net Loss",
  [LangKeys.all_transactions]: "Sabhi Transactions",
  [LangKeys.no_transactions_found_period]: "Is Period me koi Transaction nahi mila",
  [LangKeys.expense_fallback_category]: "Other Expense",

  // ================= SALES REPORT SCREEN =================
  [LangKeys.sales_report]: "Sales Report",
  [LangKeys.transactions]: "Transactions",
  [LangKeys.net_sale]: "Net Sale",
  [LangKeys.unpaid_balance]: "Baki Balance",
  [LangKeys.sales_report_share_text]: "Yeh aapka Sales Report ka summary hai.",

  // ================= PURCHASE REPORT SCREEN =================
  [LangKeys.purchase_report]: "Purchase Report",
  [LangKeys.net_purchase]: "Net Purchase",
  [LangKeys.purchase_report_share_text]: "Yeh aapka Purchase Report ka summary hai.",

  [LangKeys.filter_by_balance]: "Balance filter",
  [LangKeys.filter_all_parties]: "All parties",

  // ================= LOGOUT =================
  [LangKeys.logout_confirm]: "Kya aap logout karna chahte hain?",
  [LangKeys.confirm_logout]: "Logout",

  // ================= DEVICES =================
  [LangKeys.manage_devices]: "Devices Manage karein",
  [LangKeys.active_devices]: "Active Devices",
  [LangKeys.logout_device]: "Device Logout",
  [LangKeys.logout_device_confirm]: "Kya aap is device ko logout karna chahte hain?",
  [LangKeys.device_logged_out]: "Device successfully logout ho gaya",
  [LangKeys.no_active_devices]: "Koi active device nahi hai",
  [LangKeys.last_login]: "Last login",
  [LangKeys.this_device]: "Ye device",
  [LangKeys.loading_devices]: "Devices load ho rahe hain...",

  /* ================= SMS SETTINGS ================= */
  [LangKeys.send_whatsapp_messages]: "WhatsApp messages bhejna",
  [LangKeys.enabled]: "Chalu",
  [LangKeys.disabled]: "Band",
  [LangKeys.manage_whatsapp_settings]: "WhatsApp SMS settings manage karein",
  [LangKeys.recharge_and_control]: "Credits recharge karein aur messages control karein",

  [LangKeys.wa_message_failed]: "Message send nahi ho saka",
  // PREMIUM
  [LangKeys.plan_standard_name]: "Standard (Ads Free)",
  [LangKeys.plan_ads_free_name]: "Ads Free +",
  [LangKeys.plan_premium_name]: "Premium",
  [LangKeys.plan_recommended_tag]: "Recommended Plan",
  [LangKeys.plan_duration_30_days]: "30 din ke liye",
  [LangKeys.plan_duration_180_days]: "180 din (6 Mahine) ke liye",
  [LangKeys.plan_duration_365_days]: "365 din (1 Saal) ke liye",
  [LangKeys.plan_duration_30_days_badge]: "30 Days",
  [LangKeys.plan_save_20_percent]: "Bachat ~20%",
  [LangKeys.plan_best_value_badge]: "Best Value",
  [LangKeys.plan_best_value_plan_tag]: "Best Value Plan",
  [LangKeys.plan_most_popular_save]: "Most Popular • Bachat ₹{amount}",
  [LangKeys.plan_save_amount_tag]: "Bachat ₹{amount}",
  [LangKeys.duration_1_month]: "1 Month",
  [LangKeys.duration_6_months]: "6 Months",
  [LangKeys.duration_12_months]: "12 Months",
  [LangKeys.plan_save_text]: "Save",
  [LangKeys.benefit_no_ads]: "Koi Ads nahi (100% Ad-free experience)",
  [LangKeys.benefit_support]: "24/7 priority customer support",
  [LangKeys.benefit_all_ads_free]: "Ads Free + plan ke sabhi benefits",
  [LangKeys.benefit_multiple_devices]: "Ek saath multiple devices par login karein",
  [LangKeys.benefit_desktop_access]: "Computer/desktop par access",
  [LangKeys.benefit_create_bills]: "Bills banayein (Normal bills, GST bills)",
  [LangKeys.benefit_defaulters_list]: "Ek click me defaulters list dekhein",
  [LangKeys.benefit_organize_lists]: "Lists ke saath accounts organize karein",
  [LangKeys.benefit_manage_stocks]: "Stocks manage karein (transactions ke saath items add karein)",
  [LangKeys.benefit_financial_reports]: "Premium financial reports (PDF/Excel)",
  [LangKeys.benefit_dual_backup]: "Secure local aur cloud storage par dual backup",
  [LangKeys.benefit_unlimited_entry]: "Cashbook/Khata me unlimited entries",
  [LangKeys.benefit_unlimited_transactions]: "Unlimited transactions",
  [LangKeys.benefit_unlimited_sms]: "Unlimited SMS",
  [LangKeys.benefit_dairy_management]: "Dairy features (Doodh record, Rate chart, Bills)",
  [LangKeys.benefit_refer_earn]: "Refer Karo & Earn Karo (Free Recharge Validity)",
  [LangKeys.my_subscription_title]: "Meri Subscription",
  [LangKeys.premium_plans_title]: "Hamare Premium Plans",
  [LangKeys.active_badge_label]: "Active",
  [LangKeys.expires_on_label]: "Expires on {date}",
  [LangKeys.expired_badge_label]: "Expired",
  [LangKeys.expired_on_label]: "{date} ko expire ho gaya",
  [LangKeys.extend_plan_label]: "Plan extend karein (+{days} Days)",
  [LangKeys.days_remaining_label]: "({days} din remaining)",
  [LangKeys.secure_checkout_label]: "100% secure SSL payment",
  [LangKeys.upgrade_button]: "Upgrade karein",
  [LangKeys.downgrade_button]: "Downgrade karein",

  // REPORTS DASHBOARD
  [LangKeys.business_reports]: "Business Reports",
  [LangKeys.business_reports_desc]: "Aapke business ke liye analysis aur insights",
  [LangKeys.ledger_cashbook_reports]: "Ledger & Cashbook Reports",
  [LangKeys.billing_inventory_reports]: "Billing & Inventory Reports",
  [LangKeys.customer_ledger_statement_report]: "Customer Ledger Statement",
  [LangKeys.customer_ledger_report_desc]: "Customers ka detail transaction history aur balance statement",
  [LangKeys.supplier_ledger_statement_report]: "Supplier Ledger Statement",
  [LangKeys.supplier_ledger_report_desc]: "Suppliers ka detail transaction history aur balance statement",
  [LangKeys.cashbook_report_desc]: "Cash aur online transactions ka daily summary statement",
  [LangKeys.sales_report_desc]: "Bill-wise sales summary, total sales aur unpaid balance details",
  [LangKeys.purchase_report_desc]: "Bill-wise purchase records aur summaries",
  [LangKeys.bills_summary_report]: "Bills Summary Report",
  [LangKeys.bills_summary_report_desc]: "Sales, purchase aur profit/loss ka full analytics",
  [LangKeys.item_stock_sales_report]: "Item Stock & Sales Report",
  [LangKeys.item_stock_sales_report_desc]: "Products aur services ka stock status aur sales summary",
  [LangKeys.select_party]: "Party select karein",
  [LangKeys.search_placeholder]: "Name ya mobile se search karein...",
  [LangKeys.back_to_dashboard]: "Reports Menu par Jayein",
  [LangKeys.loading_report_data]: "Report load ho raha hai...",
  [LangKeys.no_parties_found]: "Koi party nahi mili.",
  [LangKeys.select_customer]: "Report dekhne ke liye Customer select karein",
  [LangKeys.select_supplier]: "Report dekhne ke liye Supplier select karein",
  [LangKeys.premium_feature]: "Premium Feature",
  [LangKeys.premium_lock_desc]: "Unlock karein professional billing, sales/purchase invoice reports, daybook statements, aur inventory summaries.",
  [LangKeys.upgrade_to_premium]: "Ads Free+ / Premium par upgrade karein 🚀",

  // Business Profile & Marketplace
  [LangKeys.biz_profile__marketplace_settings]: 'Online Store Settings (Moxpal Market)',
  [LangKeys.biz_profile__online_business_toggle]: 'Online Business Active Rakhein',
  [LangKeys.biz_profile__online_business_active]: 'Business Online Active Hai (Live)',
  [LangKeys.biz_profile__online_business_offline]: 'Business Online Band Hai (Offline)',
  [LangKeys.biz_profile__gps_pending_badge]: 'Online Active Hai (GPS Set Karein)',
  [LangKeys.biz_profile__online_business_sub_active]: 'Chalu karne ke baad 1-click me State, City, Area, Pincode aur GPS location set karein taki paas ke customers ko aapki dukan dikh sake.',
  [LangKeys.biz_profile__online_business_sub_offline]: 'Business ko online chalu karein taki aas-paas ke customers aapke products aur services Local Market me khoj sakein.',
  [LangKeys.biz_profile__know_benefits_btn]: '💡 Iske Fayde & Rules Jaanein',
  [LangKeys.biz_profile__benefits_modal_title]: 'Online Business Ke Fayde & Poori Jankari',
  [LangKeys.biz_profile__benefits_step1_title]: '1. Ise chalu karne se kya hoga?',
  [LangKeys.biz_profile__benefits_step1_desc]: 'Aapka business, products aur services turant Local Market me live ho jayenge. Aas-paas ke sabhi customers aapko dekh sakenge.',
  [LangKeys.biz_profile__benefits_step2_title]: '2. Aapko kya-kya karna hai?',
  [LangKeys.biz_profile__benefits_step2_desc]: '• Blue button (⚡ 1-Click) se State, District, Area, Pincode aur GPS set karein.\n• Apne products ya services add karein.',
  [LangKeys.biz_profile__benefits_step3_title]: '3. Iske kya fayde milenge?',
  [LangKeys.biz_profile__benefits_step3_desc]: '• 0% Commission (100% Free) — Koi middleman nahi.\n• Direct WhatsApp aur call par customers se orders paayein.\n• 24 ghante open digital store.',
  [LangKeys.biz_profile__benefits_btn_got_it]: 'Samajh gaya, Thanks 👍',
  [LangKeys.biz_profile__autofill_btn_title]: '⚡ 1-Click me Poora Address Auto-fill',
  [LangKeys.biz_profile__autofill_btn_sub]: 'GPS se State, City, Area & Pincode apne-aap bharein',
  [LangKeys.biz_profile__autofill_searching]: 'Location khoja ja raha hai...',
  [LangKeys.biz_profile__state_lbl]: 'State (Rajya)',
  [LangKeys.biz_profile__state_add]: 'State Add Karein',
  [LangKeys.biz_profile__state_placeholder]: 'e.g. Rajasthan, Uttar Pradesh, Gujarat...',
  [LangKeys.biz_profile__city_lbl]: 'City / District (Shahar)',
  [LangKeys.biz_profile__city_add]: 'City Add Karein',
  [LangKeys.biz_profile__city_placeholder]: 'e.g. Bikaner, Jaipur, Lucknow...',
  [LangKeys.biz_profile__area_lbl]: 'Area / Village (Gaon/Ilaqa)',
  [LangKeys.biz_profile__area_add]: 'Area Add Karein',
  [LangKeys.biz_profile__area_placeholder]: 'e.g. Sadhasar, Nokha, Sadar Bazar...',
  [LangKeys.biz_profile__pincode_lbl]: 'Pincode',
  [LangKeys.biz_profile__pincode_add]: 'Pincode Add Karein',
  [LangKeys.biz_profile__pincode_placeholder]: '6-digit Pincode daalein',
  [LangKeys.biz_profile__tagline_lbl]: 'Business Tagline / Description',
  [LangKeys.biz_profile__tagline_add]: 'Tagline Add Karein',
  [LangKeys.biz_profile__tagline_placeholder]: 'e.g. Hamare yahan shuddh taaza samaan milta hai',
  [LangKeys.biz_profile__gps_lbl]: 'Business GPS Location',
  [LangKeys.biz_profile__gps_not_set]: 'Location abhi set nahi hai',
  [LangKeys.biz_profile__gps_update_btn]: 'Update Karein',
  [LangKeys.biz_profile__gps_get_btn]: 'GPS Location Lein',
  [LangKeys.biz_profile__gps_searching]: 'Khoj rahe hain...',
  [LangKeys.biz_profile__gps_live_warning]: '⚠️ Store online hai par GPS set nahi hai! Kripya ⚡ 1-Click button se GPS set karein taki customers ko dukan dikhe.',
  [LangKeys.biz_profile__gps_turn_on_toast]: 'Kripya browser/phone ka GPS location on karein',
  [LangKeys.biz_profile__gps_permission_denied_toast]: 'Location permission allow nahi kiya gaya',
  [LangKeys.biz_profile__gps_permission_settings_toast]: 'Kripya browser settings me jaakar Location Permission on karein',
  [LangKeys.biz_profile__gps_autofill_success_toast]: 'GPS se poora address apne-aap bhar gaya!',
  [LangKeys.biz_profile__gps_error_toast]: 'Location lene me error',
  [LangKeys.biz_market_video_guide_title]: 'Local Market me Dukan Online Kaise Karein?',
  [LangKeys.biz_market_video_guide_sub]: '1 minute ka video dekhein • YouTube Guide',
  [LangKeys.item_video_guide_btn_sub]: "स्टोर व प्रोडक्ट ऑनलाइन एक्टिव करने की गाइड",
  [LangKeys.service_video_guide_btn_sub]: "काम व दुकान ऑनलाइन एक्टिव करने की गाइड",
  [LangKeys.item_marketplace_title]: "ऑनलाइन बाज़ार (Marketplace)",
  [LangKeys.item_marketplace_sub_active]: "यह प्रोडक्ट आसपास के ग्राहकों को ऑनलाइन दिखेगा, वे आपसे सीधे संपर्क कर सकेंगे और WhatsApp पर ऑर्डर कर सकेंगे।",
  [LangKeys.item_marketplace_sub_inactive]: "यह प्रोडक्ट केवल आपके निजी खाते में रहेगा।",
  [LangKeys.service_marketplace_sub_active]: "यह सर्विस आसपास के ग्राहकों को ऑनलाइन दिखेगी, वे आपसे सीधे संपर्क कर सकेंगे और WhatsApp/कॉल पर बुकिंग कर सकेंगे।",
  [LangKeys.service_marketplace_sub_inactive]: "यह सर्विस केवल आपकी दुकान/फर्म के निजी खाते में रहेगी।",
  [LangKeys.item_category_lbl]: "कैटेगरी (Category)",
  [LangKeys.change_btn]: "बदलें",
  [LangKeys.item_discount_price_lbl]: "ऑफर / डिस्काउंट भाव (₹) (वैकल्पिक)",
  [LangKeys.item_discount_price_hint]: "उदा. 450",
  [LangKeys.service_discount_price_lbl]: "ऑफर / डिस्काउंट सर्विस चार्ज (₹) (वैकल्पिक)",
  [LangKeys.service_discount_price_hint]: "उदा. 750",
  [LangKeys.item_desc_lbl]: "विवरण (Short Description) (वैकल्पिक)",
  [LangKeys.item_desc_hint]: "प्रोडक्ट का ब्रांड, मॉडल, कलर, साइज व मुख्य फीचर्स लिखें (गूगल सर्च में मदद मिलेगी)...",
  [LangKeys.service_desc_lbl]: "सर्विस का विवरण (Description) (वैकल्पिक)",
  [LangKeys.service_desc_hint]: "सर्विस के मुख्य फीचर्स, कार्यप्रणाली व अनुभव लिखें (गूगल सर्च में मदद मिलेगी)...",
  [LangKeys.market_seo_badge]: "गूगल सर्च व रैंकिंग",
  [LangKeys.category_picker_title]: "कैटेगरी चुनें (Select Category)",
  [LangKeys.category_picker_sub_item]: "सामान किस श्रेणी/व्यापार का है?",
  [LangKeys.category_picker_sub_service]: "सर्विस किस श्रेणी/कार्य की है?",
  [LangKeys.category_search_hint]: "कैटेगरी खोजें (उदा. किराना, दूध, कपड़े...)",
  [LangKeys.no_category_found]: "कोई कैटेगरी नहीं मिली",
  [LangKeys.nothing_found_for]: "के लिए कुछ नहीं मिला",
  [LangKeys.cat_title_general]: "सामान्य उत्पाद",
  [LangKeys.cat_sub_general]: "General Products",
  [LangKeys.cat_title_grocery]: "किराना, राशन व प्रोविजन",
  [LangKeys.cat_sub_grocery]: "Kirana, Grocery & Provisions",
  [LangKeys.cat_title_dairy]: "डेयरी, दूध, घी व पनीर",
  [LangKeys.cat_sub_dairy]: "Dairy, Milk, Ghee & Paneer",
  [LangKeys.cat_title_fruits_veg]: "फल व ताज़ी सब्ज़ियां",
  [LangKeys.cat_sub_fruits_veg]: "Fresh Fruits & Vegetables",
  [LangKeys.cat_title_sweets_bakery]: "मिठाई, नमकीन व बेकरी",
  [LangKeys.cat_sub_sweets_bakery]: "Sweets, Snacks & Bakery",
  [LangKeys.cat_title_restaurant_food]: "होटल, ढाबा व रेस्टोरेंट",
  [LangKeys.cat_sub_restaurant_food]: "Hotel, Food & Restaurant",
  [LangKeys.cat_title_pharmacy_medical]: "मेडिकल, दवाई व हेल्थकेयर",
  [LangKeys.cat_sub_pharmacy_medical]: "Pharmacy & Healthcare",
  [LangKeys.cat_title_agriculture_seeds]: "कृषि, खाद, बीज व कीटनाशक",
  [LangKeys.cat_sub_agriculture_seeds]: "Agri, Seeds & Fertilizer",
  [LangKeys.cat_title_animal_feed]: "पशु आहार, खल, चूरी व फीड",
  [LangKeys.cat_sub_animal_feed]: "Cattle & Animal Feed",
  [LangKeys.cat_title_electronics_mobile]: "मोबाइल, लैपटॉप व कंप्यूटर",
  [LangKeys.cat_sub_electronics_mobile]: "Electronics, Mobile & IT",
  [LangKeys.cat_title_electrical_appliances]: "इलेक्ट्रिकल्स व होम अप्लायंसेज",
  [LangKeys.cat_sub_electrical_appliances]: "Electricals & Appliances",
  [LangKeys.cat_title_clothing_garments]: "कपड़े, साड़ी व रेडीमेड",
  [LangKeys.cat_sub_clothing_garments]: "Garments, Sarees & Apparel",
  [LangKeys.cat_title_footwear_shoes]: "जूते, चप्पल व फुटवियर",
  [LangKeys.cat_sub_footwear_shoes]: "Footwear & Shoes",
  [LangKeys.cat_title_hardware_sanitary]: "हार्डवेयर, सेनेटरी व टूल्स",
  [LangKeys.cat_sub_hardware_sanitary]: "Hardware, Sanitary & Tools",
  [LangKeys.cat_title_building_materials]: "बिल्डिंग मैटेरियल व सीमेंट",
  [LangKeys.cat_sub_building_materials]: "Building Materials & Cement",
  [LangKeys.cat_title_automobile_parts]: "ऑटो पार्ट्स व स्पेयर",
  [LangKeys.cat_sub_automobile_parts]: "Automobile & Spares",
  [LangKeys.cat_title_cosmetics_beauty]: "कॉस्मेटिक्स, ब्यूटी व सैलून",
  [LangKeys.cat_sub_cosmetics_beauty]: "Beauty, Salon & Cosmetics",
  [LangKeys.cat_title_stationery_books]: "किताबें, स्टेशनरी व प्रिंटिंग",
  [LangKeys.cat_sub_stationery_books]: "Books & Stationery",
  [LangKeys.cat_title_jewellery_gifts]: "सोना-चांदी व ज्वेलरी",
  [LangKeys.cat_sub_jewellery_gifts]: "Jewellery & Gifts",
  [LangKeys.cat_title_furniture_decor]: "फर्नीचर व होम डेकोर",
  [LangKeys.cat_sub_furniture_decor]: "Furniture & Home Decor",
  [LangKeys.cat_title_kitchenware_utensils]: "बर्तन व किचनवेयर",
  [LangKeys.cat_sub_kitchenware_utensils]: "Kitchenware & Utensils",
  [LangKeys.cat_title_toys_sports]: "खिलौने व स्पोर्ट्स",
  [LangKeys.cat_sub_toys_sports]: "Toys & Sports",
  [LangKeys.cat_title_packaging_disposable]: "प्लास्टिक व डिस्पोजेबल सामान",
  [LangKeys.cat_sub_packaging_disposable]: "Packaging & Disposables",
  [LangKeys.cat_title_tailoring_boutique]: "टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_boutique]: "Tailoring & Boutique",
  [LangKeys.cat_title_meat_poultry]: "मीट, मछली व पोल्ट्री",
  [LangKeys.cat_sub_meat_poultry]: "Meat, Fish & Poultry",
  [LangKeys.cat_title_services_repair]: "रिपेयरिंग व मिस्त्री सर्विस",
  [LangKeys.cat_sub_services_repair]: "Repair & Services",
  [LangKeys.cat_title_other]: "अन्य सभी सामान व सेवाएं",
  [LangKeys.cat_sub_other]: "Other Products & Services",
  [LangKeys.cat_title_optical_eyewear]: "चश्मा व ऑप्टिकल्स",
  [LangKeys.cat_sub_optical_eyewear]: "Optical & Eyewear",
  [LangKeys.cat_title_pooja_religious]: "पूजा सामग्री व अगरबत्ती",
  [LangKeys.cat_sub_pooja_religious]: "Pooja Items & Essentials",
  [LangKeys.cat_title_watches_accessories]: "घड़ी व एक्सेसरीज",
  [LangKeys.cat_sub_watches_accessories]: "Watches & Accessories",
  [LangKeys.cat_title_generalservice]: "सामान्य सेवा (General Service)",
  [LangKeys.cat_sub_generalservice]: "All General Services & Labor",
  [LangKeys.cat_title_electronics_tv_repair]: "टीवी, LED व इलेक्ट्रॉनिक्स रिपेयरिंग",
  [LangKeys.cat_sub_electronics_tv_repair]: "TV, LED, Music System & Electronics",
  [LangKeys.cat_title_ac_appliances_repair]: "एसी, फ्रिज, वाशिंग मशीन व गीजर",
  [LangKeys.cat_sub_ac_appliances_repair]: "AC, Refrigerator & Home Appliances",
  [LangKeys.cat_title_electrician_wiring]: "इलेक्ट्रीशियन, वायरिंग व पंखे",
  [LangKeys.cat_sub_electrician_wiring]: "Electrician, Fitting & Rewinding",
  [LangKeys.cat_title_plumbing_sanitary]: "प्लंबर, पाइप व सेनेटरी फिटिंग",
  [LangKeys.cat_sub_plumbing_sanitary]: "Plumber & Sanitary Fitting",
  [LangKeys.cat_title_tailoring_stitching]: "सिलाई, टेलरिंग व बुटीक",
  [LangKeys.cat_sub_tailoring_stitching]: "Tailoring, Stitching & Boutique",
  [LangKeys.cat_title_mobile_laptop_repair]: "मोबाइल, लैपटॉप व कंप्यूटर रिपेयर",
  [LangKeys.cat_sub_mobile_laptop_repair]: "Mobile, Laptop & Desktop Service",
  [LangKeys.cat_title_automobile_mechanic]: "कार, बाइक, ऑटो सर्विस व वॉशिंग",
  [LangKeys.cat_sub_automobile_mechanic]: "Car, Bike & Auto Mechanic / Washing",
  [LangKeys.cat_title_beauty_parlour_salon]: "ब्यूटी पार्लर, सैलून व मेकओवर",
  [LangKeys.cat_sub_beauty_parlour_salon]: "Beauty Parlour, Salon & Bridal",
  [LangKeys.cat_title_carpenter_woodwork]: "बढ़ई / कारपेंटर व लकड़ी काम",
  [LangKeys.cat_sub_carpenter_woodwork]: "Carpenter, Furniture & Woodwork",
  [LangKeys.cat_title_painting_whitewash]: "पेंटिंग, पुट्टी व वाइटवॉश",
  [LangKeys.cat_sub_painting_whitewash]: "Wall Painting, Putty & Polish",
  [LangKeys.cat_title_construction_civil]: "मकान निर्माण, ठेकेदार व मिस्त्री",
  [LangKeys.cat_sub_construction_civil]: "Civil Contractor, Mason & Labour",
  [LangKeys.cat_title_agri_motor_tractor]: "ट्रैक्टर, ट्यूबवेल व मोटर सर्विस",
  [LangKeys.cat_sub_agri_motor_tractor]: "Tractor, Water Pump & Agri Motors",
  [LangKeys.cat_title_cctv_security_install]: "सीसीटीवी व सिक्योरिटी इंस्टॉलेशन",
  [LangKeys.cat_sub_cctv_security_install]: "CCTV Camera & Security Fitting",
  [LangKeys.cat_title_cleaning_pest_control]: "क्लीनिंग, वाटर टैंक व पेस्ट कंट्रोल",
  [LangKeys.cat_sub_cleaning_pest_control]: "Deep Cleaning, Water Tank & Pest",
  [LangKeys.cat_title_transport_loading]: "ट्रांसपोर्ट, लोडिंग व पिकअप",
  [LangKeys.cat_sub_transport_loading]: "Transport, Loading & Movers",
  [LangKeys.cat_title_photography_video]: "फोटोग्राफी व वीडियोग्राफी",
  [LangKeys.cat_sub_photography_video]: "Photo, Video & Studio Services",
  [LangKeys.cat_title_events_catering_tent]: "टेंट हाउस, कैटरिंग, DJ व साउंड",
  [LangKeys.cat_sub_events_catering_tent]: "Tent, Catering, DJ & Events",
  [LangKeys.cat_title_education_tuition]: "कोचिंग, ट्यूशन व क्लासेज",
  [LangKeys.cat_sub_education_tuition]: "Tuition & Education Classes",
  [LangKeys.cat_title_ca_tax_csc_emitra]: "सीए, टैक्स, CSC व ई-मित्र सेवा",
  [LangKeys.cat_sub_ca_tax_csc_emitra]: "CA, Tax, CSC, E-Mitra & Online Forms",
  [LangKeys.cat_title_healthcare_clinic_lab]: "डॉक्टर, क्लिनिक, नर्सिंग व लैब टेस्ट",
  [LangKeys.cat_sub_healthcare_clinic_lab]: "Doctor, Nursing & Diagnostics",
  [LangKeys.cat_title_other_service]: "अन्य सभी सेवाएं व कारीगरी",
  [LangKeys.cat_sub_other_service]: "Other Services & Skilled Work",
  [LangKeys.cat_title_transport_taxi]: "टैक्सी व टूर ट्रैवल्स",
  [LangKeys.cat_sub_transport_taxi]: "Taxi & Tour Travels",
  [LangKeys.cat_title_legal_advocate]: "वकील व कानूनी सलाह",
  [LangKeys.cat_sub_legal_advocate]: "Legal & Advocate Services",
  [LangKeys.cat_title_packers_movers]: "पैकर्स एंड मूवर्स",
  [LangKeys.cat_sub_packers_movers]: "Packers & Movers",
  [LangKeys.cat_title_printing_flex_banner]: "प्रिंटिंग व फ्लैक्स बोर्ड",
  [LangKeys.cat_sub_printing_flex_banner]: "Printing & Flex Banner",
  [LangKeys.cat_title_gym_fitness_yoga]: "जिम, फिटनेस व योग",
  [LangKeys.cat_sub_gym_fitness_yoga]: "Gym, Fitness & Yoga",
  [LangKeys.cat_title_cook_maid_househelp]: "कुक व घरेलू सहायिका",
  [LangKeys.cat_sub_cook_maid_househelp]: "Cook & Domestic Help",
  [LangKeys.item_photo_guide_verified]: "फ़ोटो जोड़ी गई • Tier-1 टॉप लिस्टिंग",
  [LangKeys.item_photo_guide_why_add]: "फ़ोटो क्यों जोड़ें? (5x अधिक बिक्री)",
  [LangKeys.service_photo_guide_why_add]: "फ़ोटो क्यों जोड़ें? (5x अधिक बुकिंग)",
  [LangKeys.item_photo_guide_desc]: "साफ़ रोशनी व बिना धुंधली PNG/JPG फ़ोटो लगाएं। बिना फ़ोटो की तुलना में फ़ोटो वाले प्रॉडक्ट्स ऑनलाइन बाज़ार में सबसे ऊपर दिखते हैं।",
  [LangKeys.service_photo_guide_desc]: "अपने काम, वर्कशॉप या दुकान की साफ़ PNG/JPG फ़ोटो लगाएं। बिना फ़ोटो की तुलना में फ़ोटो वाली सेवाएं नज़दीकी ग्राहकों को सबसे ऊपर दिखती हैं।",
  [LangKeys.item_video_guide_btn_title]: "ऑनलाइन लिस्टिंग सीखें (5 मिनट वीडियो)",
  [LangKeys.service_video_guide_btn_title]: "सर्विस लिस्टिंग सीखें (5 मिनट वीडियो)",
  [LangKeys.market_format_bold]: "𝗕 बोल्ड (*नाम*)",
  [LangKeys.market_format_bullet]: "• बुलेट पॉइंट",
  [LangKeys.market_format_highlight]: "⭐ मुख्य खासियत",
  [LangKeys.market_format_warranty_item]: "📦 वारंटी / विवरण",
  [LangKeys.market_format_warranty_service]: "📦 वारंटी / गारंटी",
  [LangKeys.market_format_template_item]: "⚡ तैयार ब्लॉग टेम्पलेट",
  [LangKeys.market_format_template_service]: "⚡ तैयार सर्विस टेम्पलेट",
  [LangKeys.market_seo_tip_item]: "विस्तृत विवरण लिखने से आपका प्रोडक्ट गूगल सर्च व ऑनलाइन मार्केट में तेज़ी से ग्राहकों को दिखेगा।",
  [LangKeys.market_seo_tip_service]: "विस्तृत विवरण लिखने से आपकी सर्विस गूगल सर्च व ऑनलाइन मार्केट में तेज़ी से ग्राहकों को दिखेगी।",
  [LangKeys.crop_photo_title]: "Photo Crop aur Adjust Karein",
  [LangKeys.crop_product_photo]: "Product Photo Crop aur Adjust Karein",
  [LangKeys.crop_service_photo]: "Service Photo Crop aur Adjust Karein",
  [LangKeys.crop_drag_hint]: "Finger ya mouse se photo move/drag karein",
  [LangKeys.crop_rotate_left]: "90° Left",
  [LangKeys.crop_rotate_right]: "90° Right",
  [LangKeys.crop_reset]: "Reset",
  [LangKeys.crop_ratio_square]: "1:1 (Square)",
  [LangKeys.crop_ratio_standard]: "4:3 (Standard)",
  [LangKeys.crop_ratio_free]: "Free",
  [LangKeys.crop_save_done]: "Crop aur Save Karein (Done)",
  [LangKeys.crop_compressing]: "Compress ho raha hai...",
  [LangKeys.party_or_details]: "Party / Details",
  [LangKeys.report_copied_clipboard]: "Report summary clipboard par copy ho gayi hai!",
  [LangKeys.party]: "Party",
  [LangKeys.sale]: "Sale",
  [LangKeys.purchase]: "Purchase",
  [LangKeys.expense]: "Kharcha",
  [LangKeys.ai_support_btn]: "AI Support se Turant Chat Karein (24x7 Live)",
  [LangKeys.ai_support_title]: "Moxpal AI Support",
  [LangKeys.ai_support_online_status]: "● 24x7 Instant Support",
  [LangKeys.ai_support_welcome_msg]: "Namaste! 🙏 Main *Moxpal Khata* ka smart AI assistant hoon.\\n\\nMain aapke khata, billing, dairy passbook ya subscription plan ke sabhi sawalon me madad ke liye taiyar hoon. Aap kya janna chahte hain?",
  [LangKeys.ai_support_input_hint]: "Apna sawal ya samasya yahan poochein...",
  [LangKeys.ai_support_typing]: "AI assistant jawab likh raha hai...",
  [LangKeys.ai_support_copied]: "Message copy ho gaya hai",
  [LangKeys.ai_support_net_error]: "Internet connection me samasya hai. Kripya apna network check karein ya retry karein.",
  [LangKeys.ai_support_server_error]: "Server se judne me samasya hui. Kripya punah prayas karein ya WhatsApp (+91 9929371541) par sampark karein.",
  [LangKeys.ai_support_sugg_plan]: "💎 Plan ke kya fayde hain?",
  [LangKeys.ai_support_sugg_dairy]: "🥛 Dairy Passbook kaise use karein?",
  [LangKeys.ai_support_sugg_party]: "👥 Naya customer/khata kaise add karein?",
  [LangKeys.ai_support_sugg_backup]: "💾 Data backup kaise lein?",
  [LangKeys.ai_support_sugg_bill]: "🧾 Naya bill/invoice kaise banayein?",
  [LangKeys.ai_support_clear_chat]: "Nayi Chat Shuru Karein",
  [LangKeys.ai_support_clear_title]: "Chat History Clear Karein?",
  [LangKeys.ai_support_clear_confirm]: "Kya aap purani baat-cheet clear karke nayi chat shuru karna chahte hain?",
  [LangKeys.help_center_title]: "Moxpal Khata Help Center",
  [LangKeys.help_center_sub]: "FAQs, tutorials aur customer support ka one-stop destination",
  [LangKeys.help_support_title]: "Help & Support",
  [LangKeys.help_center_heading]: "Moxpal Khata Help Center",
  [LangKeys.help_center_subheading]: "FAQs, tutorials aur customer support ke liye aapka one-stop center",
  [LangKeys.help_ai_title]: "Moxpal AI Support",
  [LangKeys.help_ai_live_badge]: "24x7 LIVE",
  [LangKeys.help_ai_online_status]: "• 24x7 Instant Support",
  [LangKeys.help_ai_desc]: "Khata, billing, inventory, dairy passbook ya plans se jude sabhi sawalon ka instant AI solution payen.",
  [LangKeys.help_ai_chat_btn]: "Chat with AI Support (24x7 Live)",
  [LangKeys.help_whatsapp_title]: "Contact Us (WhatsApp)",
  [LangKeys.help_whatsapp_sub]: "+91 99293 71541 • Official Support Team",
  [LangKeys.help_call_title]: "Call Helpline",
  [LangKeys.help_call_number]: "+91 9166277283",
  [LangKeys.help_email_title]: "Email Support",
  [LangKeys.help_email_id]: "support@moxpal.com",
  [LangKeys.help_faq_title]: "Aksar Pooche Jane Wale Sawal (FAQs)",
  [LangKeys.help_faq_1_q]: "Khata me naya customer ya supplier kaise add karein?",
  [LangKeys.help_faq_1_a]: "Home screen par \"Add Customer\" button dabayein, naam aur mobile number enter karke save karein.",
  [LangKeys.help_faq_2_q]: "Dairy passbook me doodh collection entry kaise karein?",
  [LangKeys.help_faq_2_a]: "Dairy section me jayein, \"Milk Entry\" select karein, Fat/SNF ya rate enter karke 1-click me slip bhejein.",
  [LangKeys.help_faq_3_q]: "Data backup kaise secure rehta hai?",
  [LangKeys.help_faq_3_a]: "Moxpal Khata par aapka sara data cloud server par 100% encrypted aur secure rehta hai.",
  [LangKeys.help_faq_4_q]: "Subscription plan kaise upgrade karein?",
  [LangKeys.help_faq_4_a]: "Settings me jayein, \"My Subscription\" par tap karke apna pasandida plan chunein aur payment karein.",
  [LangKeys.help_footer_call_hours]: "Call Support: Mon - Sat (Subah 9:00 se Raat 8:00)",
  [LangKeys.help_footer_ai_hours]: "AI Chat Assistant: 24 Ghante 365 Din Instant Support",
  [LangKeys.help_footer_branding]: "Moxpal Technologies • 100% Secure & Reliable • Made in India 🇮🇳",
  [LangKeys.help_feature_launch_error]: "Feature open karne me asamarth",
};

export default hinglish;